import styled, { keyframes } from 'styled-components';

const openDropdown = (dropdownHeight: number) => keyframes`
    0%{
        height: 0;
    }
    100%{
        height: ${dropdownHeight}px;
    }
`;

const closeDropdown = (dropdownHeight: number) => keyframes`
    0%{
        height: ${dropdownHeight}px;
    }
    100%{
        height: 0;
    }
`;

interface NavItemStyleI {
  height: number;
}

export const NavItemStyle = styled.div<NavItemStyleI>`
  color: inherit;
  cursor: pointer;
  margin-bottom: 32px;
  width: fit-content;
  &.with-children {
    width: 100%;
  }

  &.language-item {
    .nav-item__title {
      display: grid;
      grid-gap: 10px;
      grid-auto-flow: column;
      grid-auto-columns: 1fr;
    }
  }

  .nav-item {
    display: flex;
    width: 100%;
    border: none;
    outline: none;
    background-color: transparent;
    justify-content: space-between;
    align-items: center;
    color: inherit;
    cursor: pointer;

    &__title {
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: 1.2;
      letter-spacing: 0em;
      text-align: left;

      &--small {
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 1.6;
        letter-spacing: 0em;
        text-align: left;
        margin-left: 24px;
        margin-top: 16px;
      }
    }

    &__arrow {
      position: relative;
      height: 15px;
      width: 15px;

      img {
        position: absolute;
        top: 50%;
        left: 50%;
        height: 15px;
        transform: translate(-50%, -50%);
        transition: all 0.5s;
      }
      &.arrowActive {
        img {
          transform: translate(-50%, -50%) rotate(90deg);
        }
      }
    }
  }

  .nav-subitem {
  }

  .dropdown {
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    animation: ${(props) => closeDropdown(props.height)} 0.5s ease forwards;

    &-content {
      position: absolute;
      top: 0;
      width: 100%;
    }

    &.dropdownOpen {
      animation: ${(props) => openDropdown(props.height)} 0.5s ease forwards;
    }
  }
`;
